function fnImageTabs( i, oSection ) {

	var oSection				= $( oSection );

	$( '.tab-images > div' ).hide();
	$( '.tab-images > div:first-of-type' ).show();
	$( '.tab-nav a' ).click(function(e){
		e.preventDefault();

		var $this = $( this ),
			tabgroup = '#'+$this.parents( '.tab-nav' ).data( 'tab-group' ),
			others = $this.closest( 'li' ).siblings( 'li' ),
			target = $this.attr( 'href' );

		others.removeClass( 'active' );
		$this.closest( 'li' ).addClass( 'active' );

		$( tabgroup ).children( 'div' ).hide();
		$( target ).show();

	})


}
